import { Box, Switch } from '@ff-it/ui';
import cx from 'clsx';
import { ReactElement, useCallback } from 'react';
import { useField } from 'react-final-form';
import { filterToggle, filterToggleSwitch } from './FilterToggleChip.css';
import { filterChip, filterChipActive } from './style.css';

export function FilterToggleChip({ name, label }: { name: string; label: string }): ReactElement {
  const { input } = useField(name, { subscription: { value: true } });
  const active = !!input.value;

  const switchRef = useCallback((el: HTMLInputElement | null) => {
    if (el) {
      el.tabIndex = -1;
      el.setAttribute('aria-hidden', 'true');
    }
  }, []);

  const toggle = (): void => input.onChange(active ? undefined : true);

  return (
    <Box
      as="span"
      role="button"
      tabIndex={0}
      aria-pressed={active}
      className={cx(filterChip, filterToggle, active && filterChipActive)}
      onClick={toggle}
      onKeyDown={(e: any) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      }}
    >
      <Switch ref={switchRef} size="sm" checked={active} readOnly className={filterToggleSwitch} />
      {label}
    </Box>
  );
}
